module.exports = __webpack_public_path__ + "static/media/page18_bag.72931b01.png";